/* eslint-disable import/no-anonymous-default-export */

import Content1 from "../Attachments/Images/Content1.png";
import ProfilePhoto from "../Attachments/Images/ProfilePhoto.jpeg";
import Content2 from "../Attachments/Images/Content2.png";
import Content3 from "../Attachments/Images/Content3.png";
import Content4 from "../Attachments/Images/Content4.png";
import Content5 from "../Attachments/Images/Content5.png";
import Post1 from "../Attachments/Images/post-1.webp";
import Post2 from "../Attachments/Images/post-2.webp";
import Post3 from "../Attachments/Images/post-3.webp";
import Post4 from "../Attachments/Images/post-4.webp";
import Post5 from "../Attachments/Images/post-5.webp";
import Post6 from "../Attachments/Images/post-6.webp";
import Post7 from "../Attachments/Images/post-7.webp";
import Post8 from "../Attachments/Images/post-8.webp";
import Post9 from "../Attachments/Images/post-9.webp";
import Post10 from "../Attachments/Images/post-10.webp";

const MainPageDataEN = {
  title: "Rumah Hypno",
  name: "Melanie",
  quote:
    "“People don’t come to therapy to change their past, but their future”",
  quotePeople: "-Milton H. Erickson-",
};

const AboutPageDataEN = {
  section: "About",
  content1: {
    title: "Who Are We?",
    description: (
      <>
        Rumah Hypno is a family hypnotherapy clinic located in south jakarta. We
        provide therapy for various complaints of psychological and physical
        caused by psychological imbalances (psychosomatic). Such as addiction to
        gadgets/ alcohol/ cigarettes, depression, stress, difficulty focusing,
        hypnoslimming, couple therapy, inner child, trauma, emotional control,
        or other psychometric disorders.
        <br />
        <br />
        With professional therapists, we do the best for you.
      </>
    ),
    image: Content1,
  },
  profile: {
    title: "Profile",
    name: "MELANIE IVONE CH.,CHt.,CPHt",
    description1: (
      <>
        Born and raised in Jakarta, graduated from the University of Indonesia
        in 2006. Her interest in Human Psychology and a strong desire to help
        fellow humans in solving various psychological and physical problems,
        make Melanie studies Human Psychology.
        <br />
        <br />
        <strong>Experience as a Trainer:</strong>
      </>
    ),
    listDescription: [
      {
        list: "1. STIFIn Trainer in 2017 for the National Region. STIFIn stands for Sensing, Thinking, Intuiting, Feeling and Insting which is a concept to identify human intelligence based on the dominant brain operating system and can be identified by scanning fingerprints.",
      },
      {
        list: "2. Motivation Trainer for State Civil Apparatus (ASN) Teachers in Bekasi in 2018,",
      },
      {
        list: "3. Motivation & Entrepreneurship Trainer in Singapore in 2019.",
      },
    ],
    description2: (
      <>
        <br />
        Now Melanie has been certified by{" "}
        <strong>IBH (The Indonesian Board of Hypnotherapy)</strong> as a
        Professional Hypnotherapist and Hypnosis, who will be happy to help
        overcome your problems, and make a better version of yourself.
      </>
    ),
    image: ProfilePhoto,
  },

  content2: {
    title: "What is Hypnotherapy ?",
    description: (
      <>
        Everyone has their own worries about something. However, some people
        worry so much that it can be seen that they have mental health-related
        problems. In fact, the problem has escalated into an anxiety disorder or
        anxiety. This disorder must be treated immediately so that it does not
        continue to develop.
        <br />
        One way to overcome mental health problems is with hypnotherapy. This
        method is called effective for calming the mind so that all problems
        related to worry, because through hypnotherapy techniques allow a person
        to be able to access the subconscious which stores all memories, values,
        principles, beliefs (trust system) which is a source of consideration in
        making decisions. make decisions or sources of consideration in acting.
      </>
    ),
    image: Content2,
  },

  content3: {
    title: "Benefits Of Hypnotherapy",
    description: (
      <>
        Hypnotherapy can provide the potential to get better by treating medical
        conditions without the need for additional treatment.
        <br />
        Medical experts include hypnotherapy as a safe treatment option with
        minimal side effects. This method may not work for everyone and is often
        referred to as complementary therapy.
        <br />
        <br />
        A person receiving this therapy can experience several benefits, such as
        an increased sense of overall well-being, improved mood, and a feeling
        of hopelessness. Hypnotherapy can be used to treat several conditions,
        such as chronic pain, concentration problems, smoking control, and of
        course mental health.
        <br />
        <br />
        This therapy can be effective in helping a person reduce or control
        feelings of anxiety, stress, and sadness for the better. Hypnotherapy is
        also used to treat some negative behaviors that can make depression
        worse. Some of these behaviors may develop into something dangerous and
        even interfere with daily activities.
        <br />
        If you feel you are in a bad mental state, immediately consult your
        problem with a hypnotherapist so we can help you get better.
      </>
    ),
    image: Content3,
  },

  content4: {
    title: "How Hypnotherapy Works",
    description: (
      <>
        This therapy session is generally done between 60-90 minutes. The
        therapist will use a variety of relaxation techniques to guide the
        person into entering a hypnotic state. When this happens, you are
        certainly still in a conscious state, but the body becomes more relaxed
        and the mind is more responsive to suggestions from the therapist.
        <br />
        <br />
        Various suggestions will be made by the therapist depending on the
        condition or disorder that is trying to be overcome.
        <br />
        <br />
        Hypnotherapy can help to get rid of unwanted or unhealthy habits and
        replace them with something better. One thing that can be done is to
        increase the ability to control pain or anxiety, so that bad thought
        patterns can be eliminated so that the problem of depression is
        resolved.
      </>
    ),
    image: Content4,
  },

  content5: {
    title: "How effective is Hypnotherapy",
    image: Content5,
    description: `A 2019 study conducted by students at
      Walisongo Islamic University Semarang, Department of Psychotherapy, has proven
      that Hypnotherapy is effective for reducing the symptoms of anxiety experienced
      by pregnant women.`,
    addition: `Hypnotherapy is proven to be effective in helping people overcome problems that
      associated with stress and has also been shown to be effective in reducing weight,
      and make a person have a healthier lifestyle with a mindset
      better.`,
  },
};

const TreatmentsPageDataEN = {
  section: "Treatments",
  list1: [
    {
      title: "Hypno Parenting",
    },
    {
      title: "Hypno Slimming",
    },
    {
      title: "Hypno Inner Child",
    },
    {
      title: "Couple Therapy",
    },
    {
      title: "Anger Management",
    },
    {
      title: "Increase Self-Confidence",
    },
    {
      title: "Increase Focus",
    },
  ],
  list2: [
    {
      title: "Increase Public Speaking Skill",
    },
    {
      title: "Improve Learning Difficulties",
    },
    {
      title: "Stress Release",
    },
    {
      title: "Depression Healing",
    },
    {
      title: "Phobia Healing",
    },
  ],
  list3: [
    {
      title: "Trauma Healing",
    },
    {
      title: "Deep Sadness Healing",
    },
    {
      title: "Overthinking Healing",
    },
    {
      title: "Addiction Healing (Smoking, Alcohol, etc.)",
    },
    {
      title: "Other Psychosomatic Disorders",
    },
  ],
};

const PricingPageDataEn = {
  pricing1: {
    Title: "Ceria 1",
    Price: "IDR 1,000,000",
    Benefits: "Booking 1 Session Only",
  },
  pricing2: {
    Title: "Ceria 2",
    Price: "IDR 1,800,000",
    Benefits: "Booking for 2 Sessions",
  },
  pricing3: {
    Title: "Ceria 3",
    NormalPrice: "IDR 4,000,000",
    PriceNow: "IDR 1.500.000",
    Benefits: (
      <>
        Booking 4 Sessions
        <br />
        Discount for a "Limited" Time
      </>
    ),
  },

  offer: {
    Title: "LIMITED TIME PROMO!!",
    content:
      "Invite anyone to book a session at the RumahHypno for 3 people, and get a FREE 1X Hypnotherapy Session for you!",
  },
};

const FaqPageDataEn = [
  {
    question: "Is Hypnotherapy Safe?",
    answer:
      "Hypnotherapy Is 100% Safe. It Is A Healing Method By Using The Power Of The Subconscious Mind. Hypnotherapy Is A Self-healing, It Restructure The Client’s Mindset. The First Requirement Of Hypnotherapy Is The Client’s Will To Do The Therapy. The Safer Alternative Technique Will Be Applied For Clients With Certain Condition Such As Being A Pregnant Woman Or Having A Heart Problem.",
  },
  {
    question: "Will The Client Lose His/Her Control And Expose His/Her Secret?",
    answer:
      "During The Therapy, The Client Will Be Aware And Realise What Happens During The Process. Therapist Will Guide The Client To Relax And Focus To Explore The Root Cause.",
  },
  {
    question: "Is Hypnotherapy As Same As Brain Washing?",
    answer:
      "Of Course Not. Hypnotherapy Is Not A Brainwashing Process. The Therapist Needs The Client's Permission To Access Memory Data In The Subconscious Mind Which Allows To Open The Memory Data Needed In The Restructuring Process.",
  },
  {
    question:
      "Is Hypnosis Perform The Same As Tv Show Where The Client Becomes Unconscious Or Falls Sleep?",
    answer:
      "It’s Different. Hypnotherapy Is Providing Healing For The Subconscious Mind When The Client Is In Relax And Full Control Awareness.",
  },
  {
    question: "What Kind Of Cases That Can Be Overcome By Hypnotherapy?",
    answer:
      "Basically All Psychosomatic (Which Are Caused By The Mind Or Thought) Or Negative Emotion Such As: Sad, Angry, Frustrated, Disappointed, Revenge, Broken Heart, Afraid, Worry, Unconfident, Etc. It Can Help To Address Family Relationship Issue (Such As Couples, Parents, Children, Teens). Hypnotherapy Can Also Cure Insomnia, Trauma, Phobia, Gadget Addiction, Smoking And Other Bad Habits.",
  },
  {
    question: "Is There Any Guarantee That My Counseling Will Be Confidential?",
    answer:
      "The Client’s Information Will Be Documented Confidentially. The Therapist Must Follow The Ethical Rule From Awgi. Should Any Part Of Counseling Is To Be Shared For The Educational Purpose, Therapist Will Ask For Client’s Permission And Replace With Fictional Name.",
  },
  {
    question: "Is There Any Guarantee That The Client Will Recover Instantly?",
    answer:
      "The Basic Of Hypnotherapy Is ‘Effort Oriented Contract’, Not ‘Result Oriented Contract’. Therapist Will Do Her Best Effort To Overcome Client’s Problem. Many Of Our Clients Has Experienced The Positive Changes In Life After The Hypnotherapy Session.",
  },
  {
    question:
      "What Is The Difference Between Hypnotherapy And Regular Suggestions?",
    answer:
      "Hypnotherapy Has The Advantage That We Can Communicate In Two Directions With Our Subconscious Mind. While Ordinary Suggestions Do Not Facilitate The Response Of The Subconscious Mind.",
  },
  {
    question: "Can Hypnotherapy Change The Basic Personality Of A Person?",
    answer:
      "The Answer Is No. The Process Will Only Focus On Specific Issue The Client’s Need.",
  },
];

const PostsPageDataEn = [
  {
    image: Post1,
    postTitle:
      "Depression, Insecurity & many more are able to be Eliminated with Hypnotherapy",
    id: 1,
    link: "*/section_1",
  },
  {
    image: Post2,
    postTitle: "Anger Management",
    id: 2,
    link: "*/section_2",
  },
  {
    image: Post3,
    postTitle: "Phobia",
    id: 3,
    link: "*/section_3",
  },
  {
    image: Post4,
    postTitle: "Couple Therapy",
    id: 4,
    link: "*/section_4",
  },
  {
    image: Post5,
    postTitle: "Hypnoslimming",
    id: 5,
    link: "*/section_5",
  },
  {
    image: Post6,
    postTitle: "Addiction (Smoking, Drugs, Alcoholism, Etc.)",
    id: 6,
    link: "*/section_6",
  },
  {
    image: Post7,
    postTitle: "Inner Child Hypnosis",
    id: 7,
    link: "*/section_7",
  },
  {
    image: Post8,
    postTitle: "Cessation of Smoking",
    id: 8,
    link: "*/section_8",
  },
  {
    image: Post9,
    postTitle: "Insomnia Hypnotherapy",
    id: 9,
    link: "*/section_9",
  },
  {
    image: Post10,
    postTitle: "Does Hypnotherapy works?",
    id: 10,
    link: "*/section_10",
  },
];

export {
  MainPageDataEN,
  AboutPageDataEN,
  TreatmentsPageDataEN,
  PricingPageDataEn,
  FaqPageDataEn,
  PostsPageDataEn,
};
